import s from "../LegalPage/legalPage.module.scss";

export const CookiePolicyPage = ({ t }) => {
  const policy = t.legal.cookiePolicy;

  return (
    <section className={s.page}>
      <div className={s.contentWrapper}>
        <p className={s.pageLabel}>{t.footer.cookiePolicy}</p>
        <h1 className={s.pageTitle}>{policy.pageTitle}</h1>
        <p className={s.updatedAt}>{policy.updatedAt}</p>
        <p className={s.intro}>{policy.intro}</p>

        {policy.sections.map((section) => (
          <section key={section.title} className={s.section}>
            <h2 className={s.sectionTitle}>{section.title}</h2>
            {section.paragraphs.map((paragraph) => (
              <p key={paragraph} className={s.paragraph}>
                {paragraph}
              </p>
            ))}
          </section>
        ))}
      </div>
    </section>
  );
};
